export default {
  categoriesList: [],
  totalCategoriesPages: 0,
  categoriesTree: [],
  subcategoriesList: [],
  totalSubcategoriesPages: 0,
}
